import { useEffect, useRef } from 'react'; 
import PropTypes from 'prop-types';
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { qryParam, urlEspecial, viewCard } from '../../Constants';

const ConfirmationModal = props => {

    const { idTarjeta } = props;
    const confirmationModalRef = useRef();    
    
    useEffect(() => {
        const confirmationModal = new Modal(confirmationModalRef.current);
        confirmationModal.show();              
    },[]);
    
    return (
        <div className="modal fade clickable" id="confirmationModal" ref={confirmationModalRef} tabIndex={-1} aria-labelledby="confirmationModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">                
                    <div className="modal-body text-center">
                        <p className="my-3 text-center text-black created-card">Tu tarjeta fue creada</p>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button className="mail-to text-white btn btn-inicio" data-bs-dismiss="modal" type="button" onClick={() => redirectoIndex(idTarjeta)}>Ver tarjeta</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const redirectoIndex = idTarjeta => {    
    
    const timeToRedirect = 1000;

    setTimeout(() => {
        window.location.replace(`${urlEspecial}${qryParam}${viewCard}=${idTarjeta}`);
    }, timeToRedirect);
}

export default ConfirmationModal;

ConfirmationModal.propTypes = {
    idTarjeta: PropTypes.number.isRequired
}
